import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    background-color: ", ";\n    overflow: hidden;\n    transform: translateZ(0);\n    visibility: ", ";\n    ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 2s infinite linear;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    left: -54.89%;\n    animation: ", " 2s infinite linear;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    background-color: ", ";\n    animation: ", " 2s infinite linear;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    left: -145.17%;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    animation: ", " 2s infinite linear;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        animation-timing-function: cubic-bezier(0.2, 0.06, 0.58, 0.45);\n        transform: scaleX(0.08);\n    }\n    19.15% {\n        animation-timing-function: cubic-bezier(0.15, 0.19, 0.65, 1);\n        transform: scaleX(0.46);\n    }\n    44.15% {\n        animation-timing-function: cubic-bezier(0.26, 0, 0.21, 1.38);\n        transform: scaleX(0.73);\n    }\n    100% {\n        transform: scaleX(0.08);\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        animation-timing-function: cubic-bezier(0.15, 0, 0.52, 0.41);\n        transform: translateX(0);\n    }\n    25% {\n        animation-timing-function: cubic-bezier(0.31, 0.28, 0.8, 0.73);\n        transform: translateX(37.65%);\n    }\n    48.35% {\n        animation-timing-function: cubic-bezier(0.4, 0.63, 0.6, 0.9);\n        transform: translateX(84.39%);\n    }\n    100% {\n        transform: translateX(160.28%);\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        transform: scaleX(0.08);\n    }\n    36.65% {\n        animation-timing-function: cubic-bezier(0.33, 0.12, 0.79, 1);\n        transform: scaleX(0.08);\n    }\n    69.15% {\n        animation-timing-function: cubic-bezier(0.06, 0.11, 0.6, 1);\n        transform: scaleX(0.66);\n    }\n    100% {\n        transform: scaleX(0.08);\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        transform: translateX(0);\n    }\n    20% {\n        animation-timing-function: cubic-bezier(0.5, 0, 0.7, 0.5);\n        transform: translateX(0);\n    }\n    59.15% {\n        animation-timing-function: cubic-bezier(0.3, 0.38, 0.55, 0.96);\n        transform: translateX(83.67%);\n    }\n    100% {\n        transform: translateX(200.61%);\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import styled, { css, keyframes } from 'styled-components';
import React from 'react';
var primaryTranslateAnimation = keyframes(_templateObject());
var primaryScaleAnimation = keyframes(_templateObject2());
var SecondaryTranslateAnimation = keyframes(_templateObject3());
var SecondaryScaleAnimation = keyframes(_templateObject4());
var PrimaryBar = styled.div(_templateObject5(), primaryTranslateAnimation);
var PrimaryBarInner = styled.span(_templateObject6(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
}, primaryScaleAnimation);
var SecondaryBar = styled(PrimaryBar)(_templateObject7(), SecondaryTranslateAnimation);
var SecondaryBarInner = styled(PrimaryBarInner)(_templateObject8(), SecondaryScaleAnimation);

function size(_ref2) {
  var size = _ref2.size;
  var height = 0;

  switch (size) {
    case 'large':
      {
        height = 4;
        break;
      }

    case 'medium':
      {
        height = 2;
        break;
      }
  }

  return css(_templateObject9(), height);
}

var StyledProgress = styled.div(_templateObject10(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.gray.gray200;
}, function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading ? 'visible' : 'hidden';
}, size);
export function Progress(_a) {
  var _a$loading = _a.loading,
      loading = _a$loading === void 0 ? false : _a$loading,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'medium' : _a$size,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'indeterminate' : _a$variant,
      props = __rest(_a, ["loading", "size", "variant"]);

  return React.createElement(StyledProgress, Object.assign({
    isLoading: loading,
    size: size
  }, props), variant === 'indeterminate' ? React.createElement(React.Fragment, null, React.createElement(PrimaryBar, null, React.createElement(PrimaryBarInner, null)), React.createElement(SecondaryBar, null, React.createElement(SecondaryBarInner, null))) : null);
}